import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Container from '@mui/material/Container';
import QuestionForm from '../../components/forms/QuestionForm';
import PageCircularProgress from '../../components/PageCircularProgress/PageCircularProgress';
import { getQuestions } from '../../store/question/action';
import PageTitle from '../../components/PageTitle/PageTitle';
import { useUserAuth } from '../../contexts/UserAuthContext.js';

export default function AddQuestionPage() {
  const {
    pending,
    content,
    error,
  } = useSelector((state) => state.question);
  const dispatch = useDispatch();
  const { token } = useUserAuth();

  if (!content && !pending && !error && token !== null) {
    dispatch(getQuestions(token));
  }

  return (
    <Container maxWidth={false}>
      <PageTitle title="Ajouter une question" />
      {(
        pending || content === null
      ) && <PageCircularProgress />}
      {content !== null
        && (
          <QuestionForm />
        )}
    </Container>
  );
}
